import { c as _c } from "react/compiler-runtime";
import { ROUTES } from "@/utils/constants";
import { getCSSVariable } from "@/utils/helpers";
import { useRouter } from "next/router";
import { useEffect } from "react";
const useConsoleArtContent = {
  ascii: `
%c ██████╗ ██╗███╗   ███╗██╗████████╗ █████╗ ██████╗
%c ██╔══██╗██║████╗ ████║██║╚══██╔══╝██╔══██╗██╔══██╗
%c ██║  ██║██║██╔████╔██║██║   ██║   ███████║██████╔╝
%c ██║  ██║██║██║╚██╔╝██║██║   ██║   ██╔══██║██╔══██╗
%c ██████╔╝██║██║ ╚═╝ ██║██║   ██║   ██║  ██║██║  ██║
%c ╚═════╝ ╚═╝╚═╝     ╚═╝╚═╝   ╚═╝   ╚═╝  ╚═╝╚═╝  ╚═╝`,
  hintText: "🔍 Psst... curious developer! There's a hidden surprise somewhere on this page. Can you find it?"
};
const createStyle = (color: string, bold = true) => `color: ${color}; ${bold ? "font-weight: bold; " : ""}font-size: 0.6rem;`;
export const useConsoleArt = () => {
  const $ = _c(3);
  const router = useRouter();
  let t0;
  let t1;
  if ($[0] !== router.pathname) {
    t0 = () => {
      if (router.pathname !== ROUTES.HOME) {
        return;
      }
      const displayConsoleArt = _temp;
      displayConsoleArt();
    };
    t1 = [router.pathname];
    $[0] = router.pathname;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
};
function _temp() {
  const purple = getCSSVariable("--color-accent-3");
  const styles = Array(6).fill(createStyle(purple));
  console.log(useConsoleArtContent.ascii, ...styles);
  console.log(`%c${useConsoleArtContent.hintText}`, `color: ${purple}; font-style: italic; font-size: 0.875rem;`);
}